/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseResourceExtendedDto } from '../../models/case-resource-extended-dto';

export interface GetExtendedCaseResourceById$Params {
  id: number;
}

export function getExtendedCaseResourceById(http: HttpClient, rootUrl: string, params: GetExtendedCaseResourceById$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseResourceExtendedDto>> {
  const rb = new RequestBuilder(rootUrl, getExtendedCaseResourceById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseResourceExtendedDto>;
    })
  );
}

getExtendedCaseResourceById.PATH = '/case-resources/{id}/extended';
